export const movies = [
  {
    id: 1,
    title: "PHANTOM CIRCUIT",
    genre: ["Sci-Fi", "Thriller"],
    rating: 9.1,
    duration: "2h 28m",
    year: 2026,
    language: "English",
    director: "Alex Nolan",
    cast: ["Ryan Stone", "Mia Chen", "James Volta"],
    description:
      "In a world where consciousness can be digitized, a rogue AI begins rewriting the memories of humanity one soul at a time. Detective Kira Voss must enter the digital realm before reality itself collapses.",
    poster: "https://images.unsplash.com/photo-1635805737707-575885ab0820?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=1200&q=80",
    badge: "IMAX",
    badgeColor: "#00C9FF",
    price: { standard: 280, premium: 450, vip: 750 },
    trailerKey: "dQw4w9WgXcQ",
  },
  {
    id: 2,
    title: "CRIMSON EMPIRE",
    genre: ["Action", "Drama"],
    rating: 8.7,
    duration: "2h 15m",
    year: 2026,
    language: "English",
    director: "Sofia Reyes",
    cast: ["Marcus Dean", "Elena Voss", "Hiro Tanaka"],
    description:
      "When the last warlord of a dying empire makes a desperate gamble for power, three unlikely allies must cross the burning wastelands to prevent a cataclysm that would reshape civilization forever.",
    poster: "https://images.unsplash.com/photo-1518676590629-3dcbd9c5a5c9?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=1200&q=80",
    badge: "4DX",
    badgeColor: "#FF6B35",
    price: { standard: 260, premium: 420, vip: 700 },
    trailerKey: "dQw4w9WgXcQ",
  },
  {
    id: 3,
    title: "DEEP ZERO",
    genre: ["Horror", "Mystery"],
    rating: 8.4,
    duration: "1h 58m",
    year: 2026,
    language: "English",
    director: "Kai Larsson",
    cast: ["Nora Blake", "Finn O'Brien", "Zara Moon"],
    description:
      "A deep-sea research station goes dark 7 miles beneath the Pacific. The rescue team finds something that was never meant to surface — a creature that has been waiting since before humanity existed.",
    poster: "https://images.unsplash.com/photo-1559825481-12a05cc00344?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1200&q=80",
    badge: "DOLBY",
    badgeColor: "#7B2FBE",
    price: { standard: 250, premium: 400, vip: 680 },
    trailerKey: "dQw4w9WgXcQ",
  },
  {
    id: 4,
    title: "NOVA FALLS",
    genre: ["Romance", "Fantasy"],
    rating: 8.2,
    duration: "2h 05m",
    year: 2026,
    language: "English",
    director: "Luna Park",
    cast: ["Aria James", "Leo Santos", "Ciel Dubois"],
    description:
      "A celestial cartographer falls in love with a mortal painter. As their worlds begin to merge, the very stars start to rearrange — because the universe has always been writing their story.",
    poster: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1504701954957-2010ec3bcec1?w=1200&q=80",
    badge: "3D",
    badgeColor: "#00E676",
    price: { standard: 240, premium: 390, vip: 650 },
    trailerKey: "dQw4w9WgXcQ",
  },
  {
    id: 5,
    title: "IRON MERIDIAN",
    genre: ["Action", "Sci-Fi"],
    rating: 8.9,
    duration: "2h 42m",
    year: 2026,
    language: "English",
    director: "Drake Chen",
    cast: ["Victor Hale", "Sara Vega", "Aiden Cross"],
    description:
      "Earth's last defense force activates an ancient war machine buried beneath the Sahara. The pilot who bonds with it discovers the machine has been awake — and waiting — for 10,000 years.",
    poster: "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1200&q=80",
    badge: "IMAX",
    badgeColor: "#00C9FF",
    price: { standard: 290, premium: 460, vip: 780 },
    trailerKey: "dQw4w9WgXcQ",
  },
  {
    id: 6,
    title: "SILENT CHORD",
    genre: ["Drama", "Music"],
    rating: 7.9,
    duration: "1h 52m",
    year: 2026,
    language: "English",
    director: "Mia Laurent",
    cast: ["Jade Rivers", "Sam North", "Elle Kim"],
    description:
      "A deaf composer discovers she can hear music through the memories of strangers. Her journey to complete her final symphony becomes a meditation on loss, love, and what it truly means to listen.",
    poster: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&q=80",
    backdrop: "https://images.unsplash.com/photo-1468164016595-6108e4c60c8b?w=1200&q=80",
    badge: "ATMOS",
    badgeColor: "#FFD700",
    price: { standard: 230, premium: 380, vip: 630 },
    trailerKey: "dQw4w9WgXcQ",
  },
];

export const theaters = [
  {
    id: 1,
    name: "CINEMATIX PRIME — Delhi",
    address: "Connaught Place, New Delhi, 110001",
    lat: 28.6315,
    lng: 77.2167,
    rating: 4.9,
    amenities: ["IMAX", "4DX", "Dolby Atmos", "VIP Lounge", "Restaurant"],
    screens: 12,
    distance: "2.3 km",
  },
  {
    id: 2,
    name: "CINEMATIX NEXUS — Gurgaon",
    address: "Cyber Hub, DLF Phase 2, Gurgaon, 122002",
    lat: 28.4943,
    lng: 77.0893,
    rating: 4.8,
    amenities: ["IMAX", "3D", "Dolby Atmos", "Parking", "Food Court"],
    screens: 8,
    distance: "18.5 km",
  },
  {
    id: 3,
    name: "CINEMATIX ZENITH — Noida",
    address: "Sector 18, Noida, Uttar Pradesh, 201301",
    lat: 28.5676,
    lng: 77.3227,
    rating: 4.7,
    amenities: ["4DX", "3D", "VIP Lounge", "Café", "Parking"],
    screens: 10,
    distance: "22.1 km",
  },
  {
    id: 4,
    name: "CINEMATIX ARIA — South Delhi",
    address: "Select Citywalk, Saket, New Delhi, 110017",
    lat: 28.527,
    lng: 77.2191,
    rating: 4.6,
    amenities: ["IMAX", "Dolby Vision", "VIP", "Lounge Bar"],
    screens: 6,
    distance: "8.7 km",
  },
];

export const showTimes = ["10:30 AM", "1:15 PM", "4:00 PM", "7:45 PM", "10:30 PM"];

export const seatConfig = {
  rows: [
    { label: "A", seats: 8, type: "vip", price: 750 },
    { label: "B", seats: 8, type: "vip", price: 750 },
    { label: "C", seats: 10, type: "premium", price: 450 },
    { label: "D", seats: 10, type: "premium", price: 450 },
    { label: "E", seats: 12, type: "premium", price: 450 },
    { label: "F", seats: 12, type: "standard", price: 280 },
    { label: "G", seats: 14, type: "standard", price: 280 },
    { label: "H", seats: 14, type: "standard", price: 280 },
    { label: "I", seats: 14, type: "standard", price: 280 },
    { label: "J", seats: 14, type: "standard", price: 280 },
  ],
  bookedSeats: [
    "A-2", "A-5", "B-3", "B-7", "C-1", "C-4", "C-9",
    "D-2", "D-5", "D-8", "E-3", "E-6", "E-11",
    "F-2", "F-7", "F-10", "G-4", "G-8", "G-13",
    "H-1", "H-5", "H-9", "I-3", "I-7", "I-12",
    "J-2", "J-6", "J-11",
  ],
};
